module.exports = __webpack_public_path__ + "img/iphones.9eac8b60.png";